
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  watchEffect,
  computed,
} from "vue";
import { useMessage } from "naive-ui";
import { useStore } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as hosterModule,
  Actions as hosterActions,
  Getters as hosterGetters,
} from "@/store/enums/hosterEnums";
import inviteInfoModel from "@/core/models/hoster/inviteInfo.interface";
import locationModel from "@/core/models/share/location.interface";
import statusModel from "@/core/models/share/status.interface";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();

export default defineComponent({
  props: {
    actionModal: { type: String, required: true, default: "I" },
  },
  setup(props: any, context: any) {
    const formRef = ref<any>(null);
    const message = useMessage();
    const store = useStore();
    const inviteInfo = computed<inviteInfoModel>(
      () => store.getters[hosterModule.desc + hosterGetters.InviteInfo]
    );

    function dateDisabled(ts: number) {
      return ts < dayjs( ).subtract(1,'days').valueOf();
    }
    const statusData = computed<Array<statusModel>>(
      () => store.getters[Module.desc + Getters.EventStatuses]
    );
    const handDatePicker = ( value:number) =>
    {
      inviteInfo.value.ReplayDealine = dayjs( value).add(8, 'hours').valueOf();
    }
    return {
      formRef,
      inviteInfo,
      size: ref("large"),
      generalOptions: computed(
        () => store.getters[hosterModule.desc + hosterGetters.Location]
      ),
      rules: {
        EventName: {
          required: true,
          trigger: ["blur", "input"],
          message: "請輸入會議名稱",
        },
        EventContext: {
          required: true,
          trigger: ["blur", "input"],
          message: "請輸入會議內容",
        },
        ReplayDealine: {
          type: "number",
          required: true,
          trigger: ["blur", "change"],
          message: "請輸入回覆截止日",
        },
      },
      handleValidateButtonClick(e: any) {
        e.preventDefault();
        formRef.value.validate((errors: any) => {
          if (!errors) {
            //message.success('Valid')
          } else {
            console.log(errors);
            //message.error('Invalid')
          }
        });
      },
      dateDisabled,
      statusOptions: statusData.value.map((x) => {
        return { value: x.Value, label: x.Name };
      }),
      handDatePicker
    };
  },
});
